import Axios from "axios";
export const GetStudentProgressByStudent = async (student_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "studentProgressByStudent/",
        {
            student_id
        }
        , {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
    return res.data
}

export const GetAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff = async (subsidiary_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff/", {
        subsidiary_id
    }, {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};
export const GetTeacherClassById = async (class_id) => {
    const res = await Axios.post(process.env.REACT_APP_API_URL + "getTeacherClassById/", {
        class_id
    }, {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

export const GetReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary = async (subsidiary_id, employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getReceiptPaymentsToVerifyCashAuditByEmployeeAndSubsidiary/", {
            subsidiary_id,
            employee_id
        },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error recibiendo recibos de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetAllTeacherClassesNoEliminatedNoDaysOffNoFinished = async () => {
    const res = await Axios.get(process.env.REACT_APP_API_URL + "getAllTeacherClassesNoEliminatedNoDaysOffNoFinished/", {
        headers: {
            "x-access-token": localStorage.getItem("token"),
        },
    });
    return res.data;
};

export const PostDefinitiveWithdrawStudent = async (student_id, date_selected) => {

    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postDefinitiveWithdrawStudent/", {
            student_id, date_selected
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const PatchUpdateObservationByStudent = async (student_id, observation) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "updateObservationByStudent/",
            {
                student_id,
                observation
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error(error);
    }
};

export const GetPaymentReceiptByIDToReprint = async (receipt_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getPaymentReceiptByIDToRePrint/",
            { receipt_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error recibiendo recibos de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetStudentsWithDebts = async (subsidiaryId, status) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getStudentWithDebts/",
            { subsidiaryId, status },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo la lista de alumnos:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetAllPaymentInfoByStudent = async (studentId) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getAllPaymentInfoByStudent/",
            { studentId },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo los recibos del alumno", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const GetPaymentPlans = async () => {
    try {
        const res = await Axios.get(
            process.env.REACT_APP_API_URL + "getPaymentPlans/",
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error obteniendo los planes de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
}

export const PatchChangePaymentPlanStudent = async (payment_plan_id, student_id) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "patchChangePaymentPlanStudent/",
            {
                payment_plan_id, student_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error(error);
    }
};

export const PatchCancelReceipt = async (receipt_id, employee_id, reason, student_id) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "patchCancelReceipt/",
            {
                receipt_id,
                employee_id,
                reason,
                student_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error cancelando recibo:", error);
        return { success: false, message: error.message };
    }
};
export const PatchReceiptPaymentMethod = async (receipt_id, payment_method, exchange_rate) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "patchReceiptPaymentMethod/",
            {
                receipt_id,
                payment_method,
                exchange_rate
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error cambiando el metodo de pago del recibo:", error);
        return { success: false, message: error.message };
    }
};
export const PatchRefundReceipt = async (receipt_id, refund_type, concepts_to_refund, employee_id, specificAmount) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "PatchRefundReceipt/",
            {
                receipt_id, refund_type, concepts_to_refund, employee_id, specificAmount
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error cambiando el metodo de pago del recibo:", error);
        return { success: false, message: error.message };
    }
};

export const GetInfoReceiptToRefund = async (receipt_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "getInfoReceiptToRefund/",
            { receipt_id },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error recibiendo recibos de pago:", error);
        return { auth: true, result: [] }; // Retorna una estructura válida en caso de error
    }
};

export const PatchRemoveTeacherRelFromReceptionist = async (receptionist_employee_id, teacher_employee_id) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "patchRemoveTeacherRelFromReceptionist/",
            {
                receptionist_employee_id,
                teacher_employee_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error desasignando al mestro del recepcionista:", error);
        return { success: false, message: error.message };
    }
};
export const InsertRelTeacherWithReceptionist = async (receptionist_employee_id, teacher_employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "InsertRelTeacherWithReceptionist/",
            {
                receptionist_employee_id,
                teacher_employee_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error asignando al mestro con el recepcionista:", error);
        return { success: false, message: error.message };
    }
};
export const GetRecepcionistListInChargeByTeacherEmployeeId = async (teacher_employee_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "GetRecepcionistListInChargeByTeacherEmployeeId/",
            {
                teacher_employee_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error solicitando la lista de recepcionistas:", error);
        return { success: false, message: error.message };
    }
};

export const PatchReplaceRelTeacherWithReceptionist = async (receptionist_employee_id, teacher_employee_id) => {
    try {
        const res = await Axios.patch(
            process.env.REACT_APP_API_URL + "PatchReplaceRelTeacherWithReceptionist/",
            {
                receptionist_employee_id,
                teacher_employee_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error reemplazando al recepcionista encargado del maestro:", error);
        return { success: false, message: error.message };
    }
};
export const GetAllReceptionistWithTheirTeacherInChargeBySubsidiary  = async (subsidiary_id) => {
    try {
        const res = await Axios.post(
            process.env.REACT_APP_API_URL + "GetAllReceptionistWithTheirTeacherInChargeBySubsidiary/",
            {
                subsidiary_id
            },
            {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            }
        );
        return res.data;
    } catch (error) {
        console.error("Error solicitando la lista de recepcionistas:", error);
        return { success: false, message: error.message };
    }
};